import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'CTACard',
  props: {
    baseClass: {},
    docTypeLabel: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${__props.baseClass}__item ${__props.baseClass}__item--large`)
  }, [
    _createElementVNode("h2", {
      class: _normalizeClass(`${__props.baseClass}__title--large`)
    }, " Subscribe to get full access to the world's best " + _toDisplayString(__props.docTypeLabel) + " summaries! ", 3),
    _createVNode(_component_router_link, {
      to: { name: 'billing' },
      class: _normalizeClass(`${__props.baseClass}__btn--large btns btns--largest`)
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(" Start Your Free Trial ", -1)
      ]))]),
      _: 1
    }, 8, ["class"])
  ], 2))
}
}

})